<template>
  <div class="container create-club-container">
    <h1 class="text-center">Create Oscar Pool</h1>

    <form class="mol-center-card-width create-club-form">
      <div class="form-group">
        <label for="club-name">Oscar Pool Name</label>
        <input type="club-name" class="form-control" maxlength=64 id="club-name" v-model="clubName" />
      </div>

      <div class="form-group">
        <label for="club-description">Oscar Pool Description <span class="char-limit-text" :style="`color: ${textLimitColor};`">(max {{clubDescriptionCharLimit}} characters)</span></label>
        <textarea class="form-control" id="club-description" rows="5" :maxlength="clubDescriptionCharLimit" v-model="clubDescription"></textarea>
      </div>

      <div class="text-center">
        <button type="submit" class="btn btn-mol" ref="create-club-button" :class="{disabled: (creatingClub || !inputIsValid)}" @click.prevent="createClub">
          <span v-if="creatingClub" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
          create pool
        </button>
      </div>
    </form>

  </div>
</template>


<script>
import axios from "axios";

export default {
  name: "CreateClubPage",
  data() {
    return {
      clubName: "",
      clubDescription: "",
      clubDescriptionCharLimit: 1000,
      creatingClub: false
    }
  },
  computed: {
    textLimitColor() {
      return (
          (this.clubDescription.length >= this.clubDescriptionCharLimit)? 'red' :
              (this.clubDescription.length > (this.clubDescriptionCharLimit * 0.9))? 'goldenrod' :
                  'grey'
      ) ;
    },
    inputIsValid() {
      return (
          this.clubName?.length
          //&& this.clubDescription?.length
      );
    }
  },
  methods: {
    async createClub() {
      this.creatingClub = true;

      return axios.post("/api/club/oscar-pool/create", {
        club_name: this.clubName,
        club_description: this.clubDescription,
      })
          .then(response => {
            const clubInfo = response.data;
            this.$router.push({name: 'OscarPoolProfilePage', params: {club_id: clubInfo.club._id}});
          })
          .catch(err => {
            console.log('could not create pool', err);
          })
          .finally(() => {
            this.creatingClub = false;
          });
    }
  }
}
</script>


<style scoped>

.create-club-container {
  color: var(--mol-color-gold-text);
}

.create-club-form {

  color: var(--mol-color-gold-text);
  background-color: var(--mol-color-gold-background);

  margin-top: 50px;
  padding: 2em;

  border: solid;
  border-width: 1px;
  border-color: var(--mol-color-gold);
  border-radius: 0.375rem;

  .form-group {
    padding-top: 1.5em;
    padding-bottom: 1.5em;

    button {

    }
  }

  label {
    font-weight: bold;
    margin-bottom: 0.75em;

    .char-limit-text {
      font-weight: normal;
    }
  }

}

</style>